export enum PageBackgroundDropDownItem {
  SOLID = 'solid',
  GRADIENT = 'gradient',
  TRANSPARENT = 'transparent',
  MY_BACKGROUNDS = 'my_backgrounds',
  STOCK_IMAGE = 'stock_image',
}
